// extracted by mini-css-extract-plugin
module.exports = {"gridContainerWide":"cta_gridContainerWide__AEzo1","ctaSection":"cta_ctaSection__oi38y","ctaSectionWeb3Theme":"cta_ctaSectionWeb3Theme__UsAkr"};